import React from 'react'

export default function RoleRightPane(): React.JSX.Element {
    return (
        <div>
            RoleRightPane
            <div className="mt-4">
                Perhaps we could show some stats here like number of
                candidates/connections etc..
            </div>
            <img src="dashboard_placeholder.png" />
        </div>
    )
}
